import Certificates from './ui/Certificates';

export default Certificates;